import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Alert, FormGroup, Label, Input, Badge, Nav, NavItem, NavLink
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { createSeller, createWarehouse } from "../../../services/kargoEntegratorService";
import { uploadImageToStorage } from "../../../helpers/chatFirebase";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Eskiden "Onaylandı" (ı) ile DB'ye yazılmıştı; şimdi "Onaylandi" (i) tek standart.
// Geriye dönük uyumluluk için iki formu da kabul ediyoruz.
const isApprovedDurum = (d) => d === "Onaylandi" || d === "Onaylandı";

// Admin'in elle mağaza açarken kullandığı boş form.
// KULLANICI_ID ayrı tutulur (kullanıcı arama kutusundan seçilir).
const BOS_MAGAZA = {
  MAGAZA_ADI: "",
  VERGI_NO: "",
  VERGI_DAIRESI: "",
  ACIKLAMA: "",
  TELEFON: "",
  EMAIL: "",
  IL: "",
  ILCE: "",
  MAHALLE: "",
  POSTA_KODU: "",
  ACIK_ADRES: "",
  KISI_ADI: "",
  KISI_SOYADI: "",
  DURUM: "Onaylandi",
};

const statusBadge = (durum) => {
  if (!durum || durum === "Beklemede") return <Badge color="warning" className="fs-6">Beklemede</Badge>;
  if (isApprovedDurum(durum)) return <Badge color="success" className="fs-6">Onaylandı</Badge>;
  if (durum === "Reddedildi") return <Badge color="danger" className="fs-6">Reddedildi</Badge>;
  return <Badge color="secondary" className="fs-6">{durum}</Badge>;
};

const MagazaYonetimi = () => {
  document.title = "Mağaza Yönetimi | HarmanaGEL";

  const [magazalar, setMagazalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [statusFilter, setStatusFilter] = useState("Tümü");

  const [detailModal, setDetailModal] = useState(false);
  const [selectedMagaza, setSelectedMagaza] = useState(null);

  // Edit modal
  const [editModal, setEditModal] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  // Logo / kapak görsel yükleme durumu
  const [logoUploading, setLogoUploading] = useState(false);
  const [kapakUploading, setKapakUploading] = useState(false);

  // KE işlem loading
  const [keSellerLoading, setKeSellerLoading] = useState(false);
  const [keWarehouseLoading, setKeWarehouseLoading] = useState(false);

  // Onay / Red
  const [actionLoading, setActionLoading] = useState(false);

  // Yeni mağaza oluşturma (admin eliyle).
  // Gerekçe: kullanıcı başvuru formunu gönderemediğinde (belge yükleyemeyen
  // bayi, "Firma Önizleme"yi başvuru sanan kullanıcı, ağ hatası) kaydı elle
  // SQL yazmadan buradan açabilmek için.
  const [createModal, setCreateModal] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [createForm, setCreateForm] = useState(BOS_MAGAZA);
  const [userQuery, setUserQuery] = useState("");
  const [userResults, setUserResults] = useState([]);
  const [userSearching, setUserSearching] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  // Yeni mağazada logo/kapak + başvuru belgeleri. Mobil uygulamadaki başvuru
  // formuyla aynı alanlar ve aynı Firebase yol düzeni kullanılır.
  const [createFiles, setCreateFiles] = useState({});
  const [createUploading, setCreateUploading] = useState({});

  // Komisyon oranı editörü (detay modalı)
  const [komisyonInput, setKomisyonInput] = useState("");
  const [komisyonSaving, setKomisyonSaving] = useState(false);

  // Detay modalı açılınca komisyon inputunu mağazanın mevcut oranıyla senkronla
  useEffect(() => {
    if (selectedMagaza) {
      setKomisyonInput(selectedMagaza.KOMISYON_ORANI != null ? String(selectedMagaza.KOMISYON_ORANI) : "");
    }
  }, [selectedMagaza]);

  // Reddetme modal
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);

  // Admin notu modal
  const [noteModal, setNoteModal] = useState(false);
  const [adminNote, setAdminNote] = useState("");
  const [noteLoading, setNoteLoading] = useState(false);

  const showSuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(""), 4000);
  };

  // "Onaylı Mağaza" rozeti: mağaza yalnız kimlikle açılıyor; rozet sonradan
  // yüklenen vergi levhası onaylanınca verilir (api/MagazaRozet, ham SQL —
  // ROZET_ONAYLI kolonu EDMX'e girmeden de çalışır).
  const [rozetBekleyenler, setRozetBekleyenler] = useState([]);
  const [rozetliIdler, setRozetliIdler] = useState(new Set());
  const [rozetIslem, setRozetIslem] = useState(null);

  const fetchRozet = async () => {
    try {
      const [bRes, lRes] = await Promise.all([
        fetch(`${BASE_URL}/api/MagazaRozet/Bekleyenler`, { headers: getAuthHeaders() }),
        fetch(`${BASE_URL}/api/MagazaRozet/Liste`, { headers: getAuthHeaders() }),
      ]);
      setRozetBekleyenler(bRes.ok ? await bRes.json() : []);
      setRozetliIdler(new Set(lRes.ok ? await lRes.json() : []));
    } catch {
      /* API eski sürümdeyse kart görünmez */
    }
  };

  const rozetKarar = async (m, onay) => {
    let not = null;
    if (!onay) {
      not = window.prompt("Ret nedeni (kullanıcıya bildirilir):", "Vergi levhası okunamıyor / mağaza bilgileriyle uyuşmuyor.");
      if (not === null) return;
    } else if (!window.confirm(`${m.MAGAZA_ADI} için Onaylı Mağaza rozeti verilsin mi?`)) return;
    setRozetIslem(m.ID);
    try {
      const res = await fetch(`${BASE_URL}/api/MagazaRozet/Karar`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ MagazaId: m.ID, Onay: onay, Not: not }),
      });
      if (res.ok) {
        setSuccessMsg(onay ? "Rozet verildi." : "Rozet başvurusu reddedildi.");
        setTimeout(() => setSuccessMsg(""), 3000);
        fetchRozet();
      } else setError("Rozet kararı kaydedilemedi.");
    } finally {
      setRozetIslem(null);
    }
  };

  const fetchMagazalar = async () => {
    fetchRozet();
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/MAGAZALAR?$top=500&$orderby=BASVURU_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setMagazalar(result.value);
    } catch (err) {
      setError("Mağazalar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMagazalar();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu mağazayı silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${id})`, { method: "DELETE", headers: getAuthHeaders() });
      showSuccess("Mağaza silindi.");
      fetchMagazalar();
    } catch (err) {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const handleViewDetail = (magaza) => {
    setSelectedMagaza(magaza);
    setDetailModal(true);
  };

  const openCreate = () => {
    setCreateForm(BOS_MAGAZA);
    setCreateFiles({});
    setCreateUploading({});
    setSelectedUser(null);
    setUserQuery("");
    setUserResults([]);
    setError(null);
    setCreateModal(true);
  };

  // Kullanıcıyı ID, ad-soyad, e-posta veya telefonla arar.
  const searchUsers = async () => {
    const q = userQuery.trim();
    if (q.length < 2) {
      setError("Arama için en az 2 karakter girin.");
      return;
    }
    setUserSearching(true);
    setError(null);
    try {
      const sayi = /^\d+$/.test(q);
      const filtre = sayi
        ? `ID eq ${q} or contains(CEP_NO,'${q}')`
        : `contains(AD_SOYAD,'${q.replace(/'/g, "''")}') or contains(Mail_Adress,'${q.replace(/'/g, "''")}')`;
      const res = await fetch(
        `${BASE_URL}/KULLANICILAR?$filter=${encodeURIComponent(filtre)}&$top=15&$select=ID,AD_SOYAD,Mail_Adress,CEP_NO`,
        { headers: getAuthHeaders() }
      );
      const data = await res.json();
      const rows = data?.value || [];
      setUserResults(rows);
      if (rows.length === 0) setError("Bu aramaya uyan kullanıcı bulunamadı.");
    } catch {
      setError("Kullanıcı araması başarısız oldu.");
    } finally {
      setUserSearching(false);
    }
  };

  // Seçilen kullanıcının bilgileriyle formu ön-doldur (admin üzerine yazabilir).
  const chooseUser = (u) => {
    setSelectedUser(u);
    setUserResults([]);
    const parcalar = (u.AD_SOYAD || "").trim().split(/\s+/);
    setCreateForm((prev) => ({
      ...prev,
      EMAIL: prev.EMAIL || u.Mail_Adress || "",
      TELEFON: prev.TELEFON || u.CEP_NO || "",
      KISI_ADI: prev.KISI_ADI || parcalar.slice(0, -1).join(" ") || parcalar[0] || "",
      KISI_SOYADI: prev.KISI_SOYADI || (parcalar.length > 1 ? parcalar[parcalar.length - 1] : ""),
    }));
  };

  // Yeni mağaza modalındaki dosya yüklemeleri. Firebase yolu kullanıcı ID'sine
  // göre kurulduğu için önce kullanıcı seçilmiş olmalı.
  const CREATE_DOSYA_ALANLARI = [
    { field: "LOGO_URL",              label: "Logo",            klasor: "magaza_logolari",  onek: "logo",   accept: "image/*" },
    { field: "MAGAZALAR_KapakGorsel", label: "Kapak Görseli",   klasor: "magaza_kapaklari", onek: "kapak",  accept: "image/*" },
    { field: "VERGI_LEVHASI_URL",     label: "Vergi Levhası",   klasor: "magaza_belgeleri", onek: "vergi",  accept: "image/*,application/pdf" },
    { field: "KIMLIK_URL",            label: "Kimlik",          klasor: "magaza_belgeleri", onek: "kimlik", accept: "image/*,application/pdf" },
    { field: "IMZA_SIRKUSU_URL",      label: "İmza Sirküsü",    klasor: "magaza_belgeleri", onek: "imza",   accept: "image/*,application/pdf" },
  ];

  const handleCreateFileUpload = async (e, alan) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // aynı dosya tekrar seçilebilsin
    if (!file) return;
    if (!selectedUser) {
      setError("Önce mağaza sahibi kullanıcıyı seçin — dosya onun klasörüne yüklenecek.");
      return;
    }
    const ts = Date.now();
    const uzanti = (file.name.split(".").pop() || "jpg").toLowerCase();
    const yol =
      alan.klasor === "magaza_belgeleri"
        ? `magaza_belgeleri/${selectedUser.ID}/${alan.onek}_${ts}.${uzanti}`
        : `${alan.klasor}/${alan.onek}_${selectedUser.ID}_${ts}.${uzanti}`;

    setCreateUploading((p) => ({ ...p, [alan.field]: true }));
    setError(null);
    try {
      const url = await uploadImageToStorage(file, yol);
      setCreateFiles((p) => ({ ...p, [alan.field]: url }));
    } catch {
      setError(`${alan.label} yüklenemedi. Lütfen tekrar deneyin.`);
    } finally {
      setCreateUploading((p) => ({ ...p, [alan.field]: false }));
    }
  };

  const handleCreateSave = async () => {
    if (!selectedUser) { setError("Önce mağaza sahibi kullanıcıyı seçin."); return; }
    if (!createForm.MAGAZA_ADI.trim()) { setError("Mağaza adı zorunludur."); return; }
    if (!createForm.TELEFON.trim()) { setError("Telefon zorunludur."); return; }
    if (!createForm.IL.trim()) { setError("İl zorunludur."); return; }

    setCreateLoading(true);
    setError(null);
    try {
      // Kullanıcı başına tek aktif mağaza kuralı API'de de var; orada çakışma
      // hata DEĞİL, mevcut kaydın sessizce geri dönmesi demek. O yüzden önce
      // burada kontrol ediyoruz, yoksa admin "oluşturdum" sanıp eski kaydı görür.
      const kontrol = await fetch(
        `${BASE_URL}/MAGAZALAR?$filter=${encodeURIComponent(
          `KULLANICI_ID eq ${selectedUser.ID} and DURUM ne 'Arsivlendi' and DURUM ne 'Kapandi'`
        )}&$top=1`,
        { headers: getAuthHeaders() }
      );
      const mevcut = (await kontrol.json())?.value || [];
      if (mevcut.length > 0) {
        setError(
          `Bu kullanıcının zaten bir mağazası var: "${mevcut[0].MAGAZA_ADI}" (${mevcut[0].DURUM || "Beklemede"}). ` +
          "Yeni kayıt açmak yerine mevcut kaydı düzenleyin."
        );
        return;
      }

      const payload = { ...createForm, ...createFiles, KULLANICI_ID: selectedUser.ID };
      Object.keys(payload).forEach((k) => {
        if (typeof payload[k] === "string" && payload[k].trim() === "") delete payload[k];
      });

      const res = await fetch(`${BASE_URL}/MAGAZALAR`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const hata = await res.json().catch(() => ({}));
        setError(hata?.error?.message || hata?.Message || `Mağaza oluşturulamadı (HTTP ${res.status}).`);
        return;
      }
      showSuccess(`"${createForm.MAGAZA_ADI}" mağazası oluşturuldu.`);
      setCreateModal(false);
      fetchMagazalar();
    } catch {
      setError("Mağaza oluşturulurken hata oluştu.");
    } finally {
      setCreateLoading(false);
    }
  };

  const handleOpenEdit = (magaza) => {
    setSelectedMagaza(magaza);
    setEditForm({
      KISI_ADI: magaza.KISI_ADI || "",
      KISI_SOYADI: magaza.KISI_SOYADI || "",
      EMAIL: magaza.EMAIL || "",
      POSTA_KODU: magaza.POSTA_KODU || "",
      MAHALLE: magaza.MAHALLE || "",
      LOGO_URL: magaza.LOGO_URL || "",
      MAGAZALAR_KapakGorsel: magaza.MAGAZALAR_KapakGorsel || "",
    });
    setEditModal(true);
  };

  // Logo / kapak görselini Firebase Storage'a yükleyip URL'i forma yazar.
  // Mobil uygulama ile aynı bucket ve path düzeni kullanılır.
  const handleImageUpload = async (e, kind) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // aynı dosya tekrar seçilebilsin
    if (!file || !selectedMagaza) return;
    if (!file.type.startsWith("image/")) {
      setError("Lütfen bir görsel dosyası seçin.");
      return;
    }
    const isLogo = kind === "logo";
    const setUploading = isLogo ? setLogoUploading : setKapakUploading;
    const field = isLogo ? "LOGO_URL" : "MAGAZALAR_KapakGorsel";
    const uid = selectedMagaza.KULLANICI_ID || selectedMagaza.ID;
    const ts = Date.now();
    const path = isLogo
      ? `magaza_logolari/logo_${uid}_${ts}.jpg`
      : `magaza_kapaklari/kapak_${uid}_${ts}.jpg`;
    setUploading(true);
    try {
      const url = await uploadImageToStorage(file, path);
      setEditForm((prev) => ({ ...prev, [field]: url }));
    } catch (err) {
      setError("Görsel yüklenirken hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setUploading(false);
    }
  };

  const handleEditSave = async () => {
    setEditLoading(true);
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${selectedMagaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify(editForm),
      });
      showSuccess("Mağaza bilgileri güncellendi.");
      setEditModal(false);
      fetchMagazalar();
    } catch {
      setError("Güncelleme sırasında hata oluştu.");
    } finally {
      setEditLoading(false);
    }
  };

  // Onayla
  const handleOnayla = async (magaza) => {
    if (!window.confirm(`\"${magaza.MAGAZA_ADI}\" mağaza başvurusunu onaylamak istediğinize emin misiniz?`)) return;
    setActionLoading(true);
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${magaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ DURUM: "Onaylandi" }),
      });
      showSuccess("Mağaza başvurusu onaylandı.");
      fetchMagazalar();
    } catch {
      setError("Onaylama sırasında hata oluştu.");
    } finally {
      setActionLoading(false);
    }
  };

  // Komisyon oranını kaydet (mağaza bazlı)
  const handleKomisyonSave = async () => {
    if (!selectedMagaza) return;
    const raw = komisyonInput.trim();
    const val = raw === "" ? null : parseFloat(raw.replace(",", "."));
    if (val !== null && (!Number.isFinite(val) || val < 0 || val > 100)) {
      setError("Komisyon oranı 0-100 arasında olmalıdır.");
      return;
    }
    setKomisyonSaving(true);
    try {
      const res = await fetch(`${BASE_URL}/MAGAZALAR(${selectedMagaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ KOMISYON_ORANI: val }),
      });
      if (!res.ok) { setError("Komisyon oranı kaydedilemedi."); return; }
      showSuccess("Komisyon oranı güncellendi.");
      setSelectedMagaza({ ...selectedMagaza, KOMISYON_ORANI: val });
      fetchMagazalar();
    } catch {
      setError("Komisyon kaydı sırasında hata oluştu.");
    } finally {
      setKomisyonSaving(false);
    }
  };

  // Reddet modal aç
  const openRejectModal = (magaza) => {
    setSelectedMagaza(magaza);
    setRejectNote(magaza.ADMIN_NOTU || "");
    setRejectModal(true);
  };

  // Reddet kaydet
  const handleRejectSave = async () => {
    if (!rejectNote.trim()) {
      setError("Reddetme nedeni (admin notu) zorunludur.");
      return;
    }
    setRejectLoading(true);
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${selectedMagaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ DURUM: "Reddedildi", ADMIN_NOTU: rejectNote.trim() }),
      });
      showSuccess("Mağaza başvurusu reddedildi.");
      setRejectModal(false);
      fetchMagazalar();
    } catch {
      setError("Reddetme sırasında hata oluştu.");
    } finally {
      setRejectLoading(false);
    }
  };

  // Admin notu modal aç
  const openNoteModal = (magaza) => {
    setSelectedMagaza(magaza);
    setAdminNote(magaza.ADMIN_NOTU || "");
    setNoteModal(true);
  };

  // Admin notu kaydet
  const handleNoteSave = async () => {
    setNoteLoading(true);
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${selectedMagaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ ADMIN_NOTU: adminNote.trim() }),
      });
      showSuccess("Admin notu güncellendi.");
      setNoteModal(false);
      fetchMagazalar();
    } catch {
      setError("Not kaydedilirken hata oluştu.");
    } finally {
      setNoteLoading(false);
    }
  };

  // KargoEntegratör'de Satıcı oluştur
  const handleCreateKESeller = async (magaza) => {
    setKeSellerLoading(true);
    try {
      const result = await createSeller({
        company: magaza.MAGAZA_ADI,
        name: magaza.KISI_ADI || "",
        surname: magaza.KISI_SOYADI || "",
        phone: magaza.TELEFON || "",
        email: magaza.EMAIL || "",
        city: magaza.IL || "",
        district: magaza.ILCE || "",
        address: magaza.ACIK_ADRES || "",
        neighborhood: magaza.MAHALLE || "",
      });
      const sellerId = result.id || result.seller_id;
      await fetch(`${BASE_URL}/MAGAZALAR(${magaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ KARGO_ENTEGRATOR_SATICI_ID: sellerId }),
      });
      showSuccess(`KE Satıcı oluşturuldu! ID: ${sellerId}`);
      fetchMagazalar();
    } catch (err) {
      setError("KE Satıcı oluşturma hatası: " + err.message);
    } finally {
      setKeSellerLoading(false);
    }
  };

  // KargoEntegratör'de Depo oluştur
  const handleCreateKEWarehouse = async (magaza) => {
    if (!magaza.KARGO_ENTEGRATOR_SATICI_ID) {
      setError("Önce KE Satıcı oluşturulmalıdır.");
      return;
    }
    if (!magaza.POSTA_KODU) {
      setError("Depo oluşturmak için Posta Kodu zorunludur. Lütfen önce mağaza bilgilerini düzenleyin.");
      return;
    }
    setKeWarehouseLoading(true);
    try {
      const result = await createWarehouse({
        name: magaza.MAGAZA_ADI,
        person_name: magaza.KISI_ADI || "",
        person_surname: magaza.KISI_SOYADI || "",
        phone: magaza.TELEFON || "",
        email: magaza.EMAIL || "",
        city: magaza.IL || "",
        district: magaza.ILCE || "",
        address: magaza.ACIK_ADRES || "",
        postcode: magaza.POSTA_KODU || "",
        seller_id: magaza.KARGO_ENTEGRATOR_SATICI_ID,
      });
      const warehouseId = result.id || result.warehouse_id;
      await fetch(`${BASE_URL}/MAGAZALAR(${magaza.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ KARGO_ENTEGRATOR_DEPO_ID: warehouseId }),
      });
      showSuccess(`KE Depo oluşturuldu! ID: ${warehouseId}`);
      fetchMagazalar();
    } catch (err) {
      setError("KE Depo oluşturma hatası: " + err.message);
    } finally {
      setKeWarehouseLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    if (statusFilter === "Tümü") return magazalar;
    if (statusFilter === "Bekleyenler") return magazalar.filter(m => !m.DURUM || m.DURUM === "Beklemede");
    if (statusFilter === "Onaylandi") return magazalar.filter(m => isApprovedDurum(m.DURUM));
    return magazalar.filter(m => m.DURUM === statusFilter);
  }, [magazalar, statusFilter]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-medium">#{cell.getValue()}</span>,
    },
    {
      header: "Mağaza Adı",
      accessorKey: "MAGAZA_ADI",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => (
        <div className="d-flex align-items-center gap-2">
          {cell.row.original.LOGO_URL ? (
            <img
              src={cell.row.original.LOGO_URL}
              alt=""
              style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 36, height: 36, fontSize: 14 }}
            >
              {cell.getValue()?.charAt(0)}
            </div>
          )}
          <div>
            <div className="fw-medium">
              {cell.getValue()}
              {rozetliIdler.has(cell.row.original.ID) && (
                <Badge color="success" className="ms-1" title="Onaylı Mağaza (vergi levhası onaylı)">🏅 Onaylı</Badge>
              )}
            </div>
            <small className="text-muted">{cell.row.original.IL} / {cell.row.original.ILCE}</small>
          </div>
        </div>
      ),
    },
    {
      header: "Sahip",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : "-";
      },
    },
    {
      header: "Vergi No",
      accessorKey: "VERGI_NO",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue() || "-",
    },
    {
      header: "Telefon",
      accessorKey: "TELEFON",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue() || "-",
    },
    {
      header: "Durum",
      accessorKey: "DURUM",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => statusBadge(cell.getValue()),
    },
    {
      header: "Başvuru Tarihi",
      accessorKey: "BASVURU_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
      },
    },
    {
      header: "KE Entegrasyon",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const m = cell.row.original;
        return (
          <div className="d-flex flex-column gap-1" style={{ fontSize: 11 }}>
            <span className={m.KARGO_ENTEGRATOR_SATICI_ID ? "text-success" : "text-muted"}>
              <i className={`bx ${m.KARGO_ENTEGRATOR_SATICI_ID ? "bx-check-circle" : "bx-circle"} me-1`} />
              Satıcı: {m.KARGO_ENTEGRATOR_SATICI_ID || "—"}
            </span>
            <span className={m.KARGO_ENTEGRATOR_DEPO_ID ? "text-success" : "text-muted"}>
              <i className={`bx ${m.KARGO_ENTEGRATOR_DEPO_ID ? "bx-check-circle" : "bx-circle"} me-1`} />
              Depo: {m.KARGO_ENTEGRATOR_DEPO_ID || "—"}
            </span>
          </div>
        );
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const m = cellProps.row.original;
        const isPending = !m.DURUM || m.DURUM === "Beklemede";
        return (
          <div className="d-flex gap-1 flex-wrap">
            <Button color="info" size="sm" outline onClick={() => handleViewDetail(m)} title="Detay">
              <i className="bx bx-detail" />
            </Button>
            {isPending && (
              <>
                <Button color="success" size="sm" outline onClick={() => handleOnayla(m)} title="Onayla" disabled={actionLoading}>
                  <i className="bx bx-check" />
                </Button>
                <Button color="danger" size="sm" outline onClick={() => openRejectModal(m)} title="Reddet" disabled={actionLoading}>
                  <i className="bx bx-x" />
                </Button>
              </>
            )}
            <Button color="primary" size="sm" outline onClick={() => handleOpenEdit(m)} title="Düzenle">
              <i className="bx bx-edit" />
            </Button>
            <Button color="warning" size="sm" outline onClick={() => openNoteModal(m)} title="Admin Notu">
              <i className="bx bx-notepad" />
            </Button>
            <Button color="danger" size="sm" outline onClick={() => handleDelete(m.ID)} title="Sil">
              <i className="bx bx-trash" />
            </Button>
          </div>
        );
      },
    },
  ], [actionLoading, rozetliIdler]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Mağaza Yönetimi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          {rozetBekleyenler.length > 0 && (
            <Card className="border border-warning">
              <CardBody>
                <h5 className="mb-3">🏅 Onaylı Mağaza rozeti bekleyenler ({rozetBekleyenler.length})</h5>
                {rozetBekleyenler.map(m => (
                  <div key={m.ID} className="d-flex align-items-center justify-content-between border-bottom py-2 gap-2 flex-wrap">
                    <div>
                      <div className="fw-medium">{m.MAGAZA_ADI}</div>
                      <a href={m.VERGI_LEVHASI_URL} target="_blank" rel="noreferrer" className="small">
                        <i className="bx bx-file me-1" />Vergi levhasını aç
                      </a>
                    </div>
                    <div className="d-flex gap-1">
                      <Button size="sm" color="success" disabled={rozetIslem === m.ID} onClick={() => rozetKarar(m, true)}>
                        Rozeti Ver
                      </Button>
                      <Button size="sm" color="danger" outline disabled={rozetIslem === m.ID} onClick={() => rozetKarar(m, false)}>
                        Reddet
                      </Button>
                    </div>
                  </div>
                ))}
              </CardBody>
            </Card>
          )}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <h4 className="card-title mb-0">Mağazalar</h4>
                    <div className="d-flex align-items-center gap-2">
                      <Nav pills className="gap-1">
                        {[
                          { value: "Tümü", label: "Tümü" },
                          { value: "Bekleyenler", label: "Bekleyenler" },
                          { value: "Onaylandi", label: "Onaylandı" },
                          { value: "Reddedildi", label: "Reddedildi" },
                        ].map((s) => (
                          <NavItem key={s.value}>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={statusFilter === s.value ? "active" : ""}
                              onClick={() => setStatusFilter(s.value)}
                            >
                              {s.label}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                      <Button color="success" size="sm" onClick={openCreate}>
                        <i className="bx bx-plus me-1" />
                        Yeni Mağaza Oluştur
                      </Button>
                      <Button color="primary" size="sm" onClick={fetchMagazalar} disabled={isLoading}>
                        <i className="bx bx-refresh me-1" />
                        Yenile
                      </Button>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={filteredData}
                      isGlobalFilter={true}
                      SearchPlaceholder="Mağaza ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Detay Modal */}
      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Mağaza Detayı: {selectedMagaza?.MAGAZA_ADI}
        </ModalHeader>
        <ModalBody>
          {selectedMagaza && (
            <>
              <Row>
                <Col md={6}>
                  <h6 className="text-muted mb-2">Mağaza Bilgileri</h6>
                  <table className="table table-sm table-bordered">
                    <tbody>
                      <tr><th>Mağaza Adı</th><td>{selectedMagaza.MAGAZA_ADI}</td></tr>
                      <tr><th>Vergi No</th><td>{selectedMagaza.VERGI_NO || "-"}</td></tr>
                      <tr><th>Vergi Dairesi</th><td>{selectedMagaza.VERGI_DAIRESI || "-"}</td></tr>
                      <tr><th>Telefon</th><td>{selectedMagaza.TELEFON || "-"}</td></tr>
                      <tr><th>E-posta</th><td>{selectedMagaza.EMAIL || "-"}</td></tr>
                      <tr><th>Kişi Adı</th><td>{selectedMagaza.KISI_ADI ? `${selectedMagaza.KISI_ADI} ${selectedMagaza.KISI_SOYADI || ""}` : "-"}</td></tr>
                      <tr><th>İl / İlçe</th><td>{selectedMagaza.IL} / {selectedMagaza.ILCE}</td></tr>
                      <tr><th>Mahalle</th><td>{selectedMagaza.MAHALLE || "-"}</td></tr>
                      <tr><th>Posta Kodu</th><td>{selectedMagaza.POSTA_KODU || "-"}</td></tr>
                      <tr><th>Açık Adres</th><td>{selectedMagaza.ACIK_ADRES || "-"}</td></tr>
                      <tr><th>Kayıt Tarihi</th><td>{selectedMagaza.OLUSTURMA_TARIHI ? new Date(selectedMagaza.OLUSTURMA_TARIHI).toLocaleDateString("tr-TR") : "-"}</td></tr>
                      <tr><th>Başvuru Tarihi</th><td>{selectedMagaza.BASVURU_TARIHI ? new Date(selectedMagaza.BASVURU_TARIHI).toLocaleDateString("tr-TR") : "-"}</td></tr>
                      <tr><th>Durum</th><td>{statusBadge(selectedMagaza.DURUM)}</td></tr>
                      <tr><th>Komisyon Oranı</th><td>
                        <div className="d-flex align-items-center gap-2">
                          <Input type="number" bsSize="sm" style={{ maxWidth: 110 }} min={0} max={100} step="0.5"
                            value={komisyonInput} onChange={(e) => setKomisyonInput(e.target.value)}
                            placeholder="örn. 10" />
                          <span>%</span>
                          <Button color="primary" size="sm" onClick={handleKomisyonSave} disabled={komisyonSaving}>
                            {komisyonSaving ? "..." : "Kaydet"}
                          </Button>
                          <small className="text-muted">(boş = varsayılan)</small>
                        </div>
                      </td></tr>
                      <tr><th>Admin Notu</th><td>{selectedMagaza.ADMIN_NOTU || "-"}</td></tr>
                    </tbody>
                  </table>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-2">Sahip Bilgileri</h6>
                  <p><strong>Ad Soyad:</strong> {selectedMagaza.KULLANICILAR?.AD_SOYAD || "-"}</p>
                  <p><strong>E-posta:</strong> {selectedMagaza.KULLANICILAR?.Mail_Adress || "-"}</p>
                  <p><strong>Telefon:</strong> {selectedMagaza.KULLANICILAR?.CEP_NO || "-"}</p>
                  <hr />
                  <h6 className="text-muted mb-2">Başvuru Belgeleri</h6>
                  <div className="d-flex flex-column gap-2 mb-3">
                    {selectedMagaza.VERGI_LEVHASI_URL ? (
                      <a href={selectedMagaza.VERGI_LEVHASI_URL} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                        <i className="bx bx-file me-1" /> Vergi Levhası
                      </a>
                    ) : (
                      <span className="text-muted"><i className="bx bx-file me-1" /> Vergi Levhası: Yok</span>
                    )}
                    {selectedMagaza.KIMLIK_URL ? (
                      <a href={selectedMagaza.KIMLIK_URL} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                        <i className="bx bx-id-card me-1" /> Kimlik Belgesi
                      </a>
                    ) : (
                      <span className="text-muted"><i className="bx bx-id-card me-1" /> Kimlik Belgesi: Yok</span>
                    )}
                    {selectedMagaza.IMZA_SIRKUSU_URL ? (
                      <a href={selectedMagaza.IMZA_SIRKUSU_URL} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                        <i className="bx bx-pen me-1" /> İmza Sirküsü
                      </a>
                    ) : (
                      <span className="text-muted"><i className="bx bx-pen me-1" /> İmza Sirküsü: Yok</span>
                    )}
                  </div>
                  <hr />
                  <h6 className="text-muted mb-2">KargoEntegratör Entegrasyonu</h6>
                  <table className="table table-sm table-bordered mb-3">
                    <tbody>
                      <tr>
                        <th>Satıcı ID</th>
                        <td>
                          {selectedMagaza.KARGO_ENTEGRATOR_SATICI_ID ? (
                            <span className="text-success fw-medium">{selectedMagaza.KARGO_ENTEGRATOR_SATICI_ID}</span>
                          ) : <span className="text-muted">Henüz oluşturulmadı</span>}
                        </td>
                      </tr>
                      <tr>
                        <th>Depo ID</th>
                        <td>
                          {selectedMagaza.KARGO_ENTEGRATOR_DEPO_ID ? (
                            <span className="text-success fw-medium">{selectedMagaza.KARGO_ENTEGRATOR_DEPO_ID}</span>
                          ) : <span className="text-muted">Henüz oluşturulmadı</span>}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="d-flex flex-column gap-2">
                    <Button
                      color="primary"
                      size="sm"
                      disabled={!!selectedMagaza.KARGO_ENTEGRATOR_SATICI_ID || keSellerLoading}
                      onClick={() => handleCreateKESeller(selectedMagaza)}
                    >
                      {keSellerLoading ? <><Spinner size="sm" className="me-1" />Oluşturuluyor...</> : <><i className="bx bx-user-plus me-1" />KE Satıcı Oluştur</>}
                    </Button>
                    <Button
                      color="success"
                      size="sm"
                      disabled={!!selectedMagaza.KARGO_ENTEGRATOR_DEPO_ID || keWarehouseLoading}
                      onClick={() => handleCreateKEWarehouse(selectedMagaza)}
                    >
                      {keWarehouseLoading ? <><Spinner size="sm" className="me-1" />Oluşturuluyor...</> : <><i className="bx bx-building-house me-1" />KE Depo Oluştur</>}
                    </Button>
                  </div>
                  <hr />
                  <p><strong>Açıklama:</strong></p>
                  <p className="text-muted">{selectedMagaza.ACIKLAMA || "Açıklama yok"}</p>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" outline onClick={() => { setDetailModal(false); handleOpenEdit(selectedMagaza); }}>
            <i className="bx bx-edit me-1" />Düzenle
          </Button>
          <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>

      {/* Düzenleme Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          Mağaza Bilgilerini Düzenle: {selectedMagaza?.MAGAZA_ADI}
        </ModalHeader>
        <ModalBody>
          {/* Kapak fotoğrafı + logo yükleme */}
          <FormGroup>
            <Label>Kapak Fotoğrafı</Label>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: 120,
                borderRadius: 8,
                overflow: "hidden",
                background: "#f1f3f5",
                border: "1px solid #dee2e6",
              }}
            >
              {editForm.MAGAZALAR_KapakGorsel ? (
                <img
                  src={editForm.MAGAZALAR_KapakGorsel}
                  alt="Kapak"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#adb5bd",
                    fontSize: 13,
                  }}
                >
                  Kapak fotoğrafı yok
                </div>
              )}
              {/* Logo önizleme (kapağın üzerinde, sol altta) */}
              <div
                style={{
                  position: "absolute",
                  left: 12,
                  bottom: 8,
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "3px solid #fff",
                  background: "#e9ecef",
                }}
              >
                {editForm.LOGO_URL ? (
                  <img
                    src={editForm.LOGO_URL}
                    alt="Logo"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : null}
              </div>
            </div>
            <div className="d-flex gap-2 mt-2">
              <label className="btn btn-outline-primary btn-sm mb-0">
                {kapakUploading ? (
                  <><Spinner size="sm" className="me-1" />Yükleniyor...</>
                ) : (
                  <><i className="mdi mdi-image-area me-1" />Kapak Seç</>
                )}
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  disabled={kapakUploading}
                  onChange={(e) => handleImageUpload(e, "kapak")}
                />
              </label>
              <label className="btn btn-outline-secondary btn-sm mb-0">
                {logoUploading ? (
                  <><Spinner size="sm" className="me-1" />Yükleniyor...</>
                ) : (
                  <><i className="mdi mdi-storefront-outline me-1" />Logo Seç</>
                )}
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  disabled={logoUploading}
                  onChange={(e) => handleImageUpload(e, "logo")}
                />
              </label>
            </div>
          </FormGroup>
          <hr />
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Kişi Adı</Label>
                <Input
                  value={editForm.KISI_ADI || ""}
                  onChange={(e) => setEditForm({ ...editForm, KISI_ADI: e.target.value })}
                  placeholder="Satıcının adı"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Kişi Soyadı</Label>
                <Input
                  value={editForm.KISI_SOYADI || ""}
                  onChange={(e) => setEditForm({ ...editForm, KISI_SOYADI: e.target.value })}
                  placeholder="Satıcının soyadı"
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>E-posta</Label>
            <Input
              type="email"
              value={editForm.EMAIL || ""}
              onChange={(e) => setEditForm({ ...editForm, EMAIL: e.target.value })}
              placeholder="ornek@email.com"
            />
          </FormGroup>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Posta Kodu</Label>
                <Input
                  value={editForm.POSTA_KODU || ""}
                  onChange={(e) => setEditForm({ ...editForm, POSTA_KODU: e.target.value })}
                  placeholder="34000"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Mahalle</Label>
                <Input
                  value={editForm.MAHALLE || ""}
                  onChange={(e) => setEditForm({ ...editForm, MAHALLE: e.target.value })}
                  placeholder="Mahalle adı"
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={editLoading}>İptal</Button>
          <Button color="primary" onClick={handleEditSave} disabled={editLoading || logoUploading || kapakUploading}>
            {editLoading ? <><Spinner size="sm" className="me-1" />Kaydediliyor...</> : "Kaydet"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Reddetme Modal */}
      <Modal isOpen={rejectModal} toggle={() => setRejectModal(false)} centered>
        <ModalHeader toggle={() => setRejectModal(false)}>
          Başvuru Reddet: {selectedMagaza?.MAGAZA_ADI}
        </ModalHeader>
        <ModalBody>
          <Alert color="info">
            Reddetme nedenini aşağıya yazınız. Bu not mağaza sahibiyle paylaşılabilir.
          </Alert>
          <FormGroup>
            <Label>Reddetme Nedeni (Admin Notu) <span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              rows={4}
              value={rejectNote}
              onChange={(e) => setRejectNote(e.target.value)}
              placeholder="Örn: Eksik evrak, geçersiz vergi numarası..."
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setRejectModal(false)} disabled={rejectLoading}>İptal</Button>
          <Button color="danger" onClick={handleRejectSave} disabled={rejectLoading}>
            {rejectLoading ? <><Spinner size="sm" className="me-1" />Kaydediliyor...</> : "Reddet"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Admin Notu Modal */}
      <Modal isOpen={noteModal} toggle={() => setNoteModal(false)} centered>
        <ModalHeader toggle={() => setNoteModal(false)}>
          Admin Notu: {selectedMagaza?.MAGAZA_ADI}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Admin Notu</Label>
            <Input
              type="textarea"
              rows={4}
              value={adminNote}
              onChange={(e) => setAdminNote(e.target.value)}
              placeholder="Mağaza hakkında iç not..."
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setNoteModal(false)} disabled={noteLoading}>İptal</Button>
          <Button color="primary" onClick={handleNoteSave} disabled={noteLoading}>
            {noteLoading ? <><Spinner size="sm" className="me-1" />Kaydediliyor...</> : "Kaydet"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Yeni Mağaza Oluştur Modal */}
      <Modal isOpen={createModal} toggle={() => setCreateModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setCreateModal(false)}>
          <i className="bx bx-store-alt me-2 text-success" />
          Yeni Mağaza Oluştur
        </ModalHeader>
        <ModalBody>
          <Alert color="info" className="mb-3">
            Mağaza, seçilen kullanıcının adına açılır. Kullanıcı uygulamada
            "Mağazam" ekranından bilgilerini düzenleyebilir.
          </Alert>

          {/* 1) Kullanıcı seçimi */}
          <FormGroup>
            <Label>Mağaza Sahibi <span className="text-danger">*</span></Label>
            {selectedUser ? (
              <div className="d-flex align-items-center justify-content-between border rounded p-2">
                <div>
                  <strong>#{selectedUser.ID}</strong> — {selectedUser.AD_SOYAD}
                  <div className="text-muted small">
                    {selectedUser.Mail_Adress} · {selectedUser.CEP_NO}
                  </div>
                </div>
                <Button color="link" size="sm" onClick={() => setSelectedUser(null)}>
                  Değiştir
                </Button>
              </div>
            ) : (
              <>
                <div className="d-flex gap-2">
                  <Input
                    value={userQuery}
                    onChange={(e) => setUserQuery(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); searchUsers(); } }}
                    placeholder="Kullanıcı ID, ad soyad, e-posta veya telefon"
                  />
                  <Button color="primary" onClick={searchUsers} disabled={userSearching}>
                    {userSearching ? <Spinner size="sm" /> : <i className="bx bx-search" />}
                  </Button>
                </div>
                {userResults.length > 0 && (
                  <div className="border rounded mt-2" style={{ maxHeight: 220, overflowY: "auto" }}>
                    {userResults.map((u) => (
                      <div
                        key={u.ID}
                        className="p-2 border-bottom"
                        style={{ cursor: "pointer" }}
                        onClick={() => chooseUser(u)}
                      >
                        <strong>#{u.ID}</strong> — {u.AD_SOYAD}
                        <div className="text-muted small">{u.Mail_Adress} · {u.CEP_NO}</div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </FormGroup>

          {/* 2) Mağaza bilgileri */}
          <Row>
            <Col md={8}>
              <FormGroup>
                <Label>Mağaza Adı <span className="text-danger">*</span></Label>
                <Input
                  value={createForm.MAGAZA_ADI}
                  onChange={(e) => setCreateForm({ ...createForm, MAGAZA_ADI: e.target.value })}
                  placeholder="Örn: MANSUROĞULLARI YAPI OTOMOTİV"
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Durum</Label>
                <Input
                  type="select"
                  value={createForm.DURUM}
                  onChange={(e) => setCreateForm({ ...createForm, DURUM: e.target.value })}
                >
                  <option value="Onaylandi">Onaylandı (hemen yayında)</option>
                  <option value="Beklemede">Beklemede (onay kuyruğuna düşer)</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Telefon <span className="text-danger">*</span></Label>
                <Input
                  value={createForm.TELEFON}
                  onChange={(e) => setCreateForm({ ...createForm, TELEFON: e.target.value })}
                  placeholder="05XXXXXXXXX"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>E-posta</Label>
                <Input
                  value={createForm.EMAIL}
                  onChange={(e) => setCreateForm({ ...createForm, EMAIL: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Vergi No</Label>
                <Input
                  value={createForm.VERGI_NO}
                  onChange={(e) => setCreateForm({ ...createForm, VERGI_NO: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Vergi Dairesi</Label>
                <Input
                  value={createForm.VERGI_DAIRESI}
                  onChange={(e) => setCreateForm({ ...createForm, VERGI_DAIRESI: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>İl <span className="text-danger">*</span></Label>
                <Input
                  value={createForm.IL}
                  onChange={(e) => setCreateForm({ ...createForm, IL: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>İlçe</Label>
                <Input
                  value={createForm.ILCE}
                  onChange={(e) => setCreateForm({ ...createForm, ILCE: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Mahalle</Label>
                <Input
                  value={createForm.MAHALLE}
                  onChange={(e) => setCreateForm({ ...createForm, MAHALLE: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label>Açık Adres</Label>
            <Input
              type="textarea"
              rows={2}
              value={createForm.ACIK_ADRES}
              onChange={(e) => setCreateForm({ ...createForm, ACIK_ADRES: e.target.value })}
            />
          </FormGroup>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Yetkili Adı</Label>
                <Input
                  value={createForm.KISI_ADI}
                  onChange={(e) => setCreateForm({ ...createForm, KISI_ADI: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Yetkili Soyadı</Label>
                <Input
                  value={createForm.KISI_SOYADI}
                  onChange={(e) => setCreateForm({ ...createForm, KISI_SOYADI: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup className="mb-0">
            <Label>Açıklama</Label>
            <Input
              type="textarea"
              rows={3}
              value={createForm.ACIKLAMA}
              onChange={(e) => setCreateForm({ ...createForm, ACIKLAMA: e.target.value })}
              placeholder="Örn: BATMAN TÜMOSAN BÖLGE BAYİ"
            />
          </FormGroup>

          {/* Logo / kapak / başvuru belgeleri */}
          <hr />
          <Label className="fw-bold d-block mb-2">Görseller ve Belgeler</Label>
          {!selectedUser && (
            <div className="text-muted small mb-2">
              Dosyalar mağaza sahibinin klasörüne yüklenir — önce yukarıdan kullanıcıyı seçin.
            </div>
          )}
          <Row>
            {CREATE_DOSYA_ALANLARI.map((alan) => (
              <Col md={6} key={alan.field}>
                <FormGroup>
                  <Label className="small mb-1">{alan.label}</Label>
                  <div className="d-flex align-items-center gap-2">
                    <Input
                      type="file"
                      accept={alan.accept}
                      bsSize="sm"
                      disabled={!selectedUser || createUploading[alan.field]}
                      onChange={(e) => handleCreateFileUpload(e, alan)}
                    />
                    {createUploading[alan.field] && <Spinner size="sm" />}
                    {createFiles[alan.field] && (
                      <a
                        href={createFiles[alan.field]}
                        target="_blank"
                        rel="noreferrer"
                        className="text-success text-nowrap small"
                        title="Yüklendi — görüntülemek için tıklayın"
                      >
                        <i className="mdi mdi-check-circle" /> Yüklendi
                      </a>
                    )}
                  </div>
                </FormGroup>
              </Col>
            ))}
          </Row>
          <div className="text-muted small">
            Belgeler için resim ya da PDF yükleyebilirsiniz. Sonradan listedeki
            "Düzenle" ile de değiştirilebilir.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setCreateModal(false)} disabled={createLoading}>
            İptal
          </Button>
          <Button color="success" onClick={handleCreateSave} disabled={createLoading}>
            {createLoading ? <><Spinner size="sm" className="me-1" />Oluşturuluyor...</> : "Mağazayı Oluştur"}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default MagazaYonetimi;
